import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs';
import { debugLog, isDebugLogEnabled, isDebugPayloadEnabled, maskSensitive } from './debug-log';

let requestSeq = 0;

/**
 * Log every HTTP request going out and every response/error coming back.
 * Controlled by environment.debugLog.enabled / .http / .payload
 */
export const httpDebugLogInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isDebugLogEnabled('http')) {
    return next(req);
  }

  const id = ++requestSeq;
  const startedAt = performance.now();
  const withPayload = isDebugPayloadEnabled();
  const target = `${req.method} ${req.urlWithParams}`;
  const elapsed = (): string => `${Math.round(performance.now() - startedAt)}ms`;

  debugLog('http', `→ OUT #${id} ${target}`, withPayload && req.body != null ? { body: maskSensitive(req.body) } : undefined);

  return next(req).pipe(
    tap({
      next: (event) => {
        if (!(event instanceof HttpResponse)) return;
        debugLog(
          'http',
          `← IN  #${id} ${event.status} ${target} (${elapsed()})`,
          withPayload ? { body: maskSensitive(event.body) } : undefined,
        );
      },
      error: (err: unknown) => {
        const status = err instanceof HttpErrorResponse ? err.status : 'ERR';
        debugLog('http', `✕ IN  #${id} ${status} ${target} (${elapsed()})`, {
          error: err instanceof HttpErrorResponse ? maskSensitive(err.error) : err,
        });
      },
    }),
  );
};
